export interface ICustomError {
  title: string;
  message?: string | null | undefined;
  severity?: string | null | undefined;
  error?: any;
}

export class CustomError extends Error {
  public readonly title: string;
  public readonly cause?: any;
  public readonly severity?: string | null | undefined;

  constructor(title: string, message?: string | null | undefined, severity?: string | null | undefined, error?: Error) {
    super(message || error?.message || "");
    this.name = "CustomError";
    this.title = title;
    this.cause = error;
    this.severity = severity;
  }
}
